// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__pILmU","title":"Logo_title__KQ+WL","icon":"Logo_icon__vsUQL"};